import { 
    AppBar,
    Toolbar,
 } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";
import OnBoardingHeader from "../../views/landing/onBoardingHeader";


export default function VerifyUser() {
    const history = useHistory();
    return (
        <div>
            <OnBoardingHeader />
            <div className="signUpContainer">
                <div className="cardContainer">
                    <img src="/images/verify_user.svg" alt="declined user" className="decImgWidth"/>
                    <div className="verifyTextWrapper margin_bottom_40">
                        {/* <img src="images/blue_info_icon.svg" alt="info icon" className="infoImgWidth"/> */}
                        <p className="declineTxt">
                            We were unable to verify your identity. Please bear with us as we make further checks.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}